import { render, staticRenderFns } from "./TravelForm.vue?vue&type=template&id=50034b39&scoped=true"
import script from "./TravelForm.vue?vue&type=script&lang=ts"
export * from "./TravelForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50034b39",
  null
  
)

export default component.exports